<template>
    <!--
        latestImageIdとunsavedPuriCountはこのheader,footerタイプの組み合わせだと必要ないが
        BaseLayoutの設計上必須propsにしているので、ダミーの値を渡している
    -->
    <base-layout
        :header-type="headerType.LOGOONLY"
        :footer-type="footerType.COPYRIGHTONLY"
        latest-image-id="dummy"
        unsaved-puri-count="0"
    >
        <jhs-free-heading/>
        <template v-if="!isChange">
            <div class="c-img-stepnavi">
                <img :src="buildImageUrl('stepnavi_02.png')" alt="STEP2 確認書類の提出"/>
            </div>
            <heading-bg title="本人確認書類の撮影"/>
            <div class="l-element">
                <p class="m-text-normal is-mgb0 is-primary is-text-center is-text-bold">
                    年齢確認のために<br>
                    中学生であることが証明できる<br>
                    書類の撮影が必要だよ！
                </p>
            </div>
            <div class="l-element" >
                <img :src="buildImageUrl('available_documents.png')" alt="利用可能な書類 学生証/生徒手帳 中学校の在学証明書 中学校の入学通知書 小学校の卒業証書"/>
            </div>
            <div class="l-element" >
                <img :src="buildImageUrl('not-applicable.png')" alt="健康保険証・マイナンバーカードは対象外です"/>
            </div>
        </template>

        <template v-else>
            <div class="l-element">
                <p class="m-text-normal is-mgb0 is-primary is-text-center is-text-bold">注意してね！</p>
            </div>
            <div class="l-element">
                <p class="m-text-normal is-mgb0">
                    情報の入力の途中でブラウザの「閉じる×」や「戻る」ボタンを押した場合、入力した内容が消えてしまう場合があるのでご注意ください。</p>
            </div>
            <heading-bg title="提出書類の変更"/>
        </template>

        <jhs-free-form-upload-certificate
            :is-change="isChange"
            @isCompleteFormInput="isCompleteFormInput = $event"
        />

        <div data-jest="jhs-free-buttons-bottom">
            <div class="l-element" :class="{'is-mgb24': isChange}">
                <btn
                    @click="nextInputConfirmation"
                    :priority="isCompleteFormInput ? cssPriority.PRIMARY : cssPriority.DISABLED"
                    :is-router-link="true"
                    :text="nextBtnText"
                    data-jest="jhs-free-button-next"
                />
            </div>
            <div v-if="!isChange" class="l-element is-mgb24">
                <btn
                    :link="inputProfileUrl"
                    :is-router-link="true"
                    text="申し込み情報に戻る"
                    data-jest="jhs-free-button-back"
                />
            </div>
        </div>

    </base-layout>
</template>

<script>
import BaseLayout from "../../templates/BaseLayout.vue";
import ListText from "../../atoms/ListText.vue";
import HeadingBg from "../../atoms/HeadingBg.vue";
import HeadingAppealPrimary from "../../atoms/HeadingAppealPrimary.vue";
import Btn from "../../atoms/Btn.vue";
import Table from "../../atoms/Table.vue"
import JhsFreeHeading from "../../molecules/JhsFreeHeading.vue";
import JhsFreeFormUploadCertificate from "../../organisms/JhsFreeFormUploadCertificate.vue";
import LinkText from "../../atoms/LinkText.vue";
import {cssPriority} from "../../../view-model/enum/CSSPriority";
import * as metaInformationUtil from "../../../util/metaInformationUtil.js";
import {getGa4EventLabel} from "../../../util/Ga4EventUtil";
import {headerType} from "../../../view-model/enum/HeaderType";
import {footerType} from "../../../view-model/enum/FooterType";
import * as urlUtil from "../../../util/UrlUtil";

export default {
    name: "JhsFreeInputCertificate",
    components: {
        BaseLayout,
        JhsFreeHeading,
        HeadingBg,
        ListText,
        Btn,
        Table,
        HeadingAppealPrimary,
        JhsFreeFormUploadCertificate,
        LinkText
    },
    props: {
        /**
         * title
         */
        title: {
            type: String,
            required: true
        },
        /**
         * description
         */
        description: {
            type: String,
            required: true
        },
        /**
         * 変更ページか
         */
        isChange: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    data() {
        return {
            headerType: headerType,
            footerType: footerType,
            cssPriority: cssPriority,
            isCompleteFormInput: false,
            inputConfirmationUrl: '/confirm/last',
            inputProfileUrl: '/input/profile',
        }
    },
    computed: {
        nextBtnText() {
            if (this.isChange) {
                return 'この内容で保存する';
            } else {
                return '次へ'
            }
        },
    },
    mounted() {
        this.setTitleAndDesc();

        // 広告タグ送信
        this.sendLineTag();
    },
    methods: {
        setTitleAndDesc() {
            metaInformationUtil.setTitleAndDescription(this.title, this.description)
        },
        nextInputConfirmation() {
            if(!this.isCompleteFormInput) return;
            getGa4EventLabel('TAP_BUTTON', 'JHS_FREE_CERTIFICATE_ADDED')
            const elementIdList = ["school-issued-front", "school-issued-back"]
            elementIdList.forEach(id => {
                const c = document.getElementById(`canvas_${id}`);
                if (c) {
                    c.width = 0;
                    c.height = 0;
                }
            })
            this.$router.push(this.inputConfirmationUrl)
        },
        /*
         * VOYAGERFRONT-6111 LINEイベントコード設置
         * ユニテのため切り出している
         */
        sendLineTag() {
            _lt('send', 'cv', {
                type: 'event3'
            }, ['00959236-1b74-4654-8bc6-3b291d37ee67']);
        },
        /**
         * 画像のURLを組み立てる
         * @param {string} imgName 画像名
         */
        buildImageUrl(imgName) {
            return urlUtil.imageUrlUtil.buildS3ImageUrl('img/jhs-free/' + imgName)
        },
    },
}
</script>

<style scoped lang="scss">
@use "sass:math";

$grid-base: 4.27vw; // 375px幅に対して16px
$grid-consistent: $grid-base * 0.5; // 375px幅に対して8px

.c-img-stepnavi {
    padding: $grid-consistent 0;
    width: percentage(math.div(236px, 343px));
    margin: 0 auto;
}

.c-jhs-free-lp-video {
    width: 100%;
    height: auto;
}

</style>
